const getExt = filename => filename.split('.').pop();
const getFormat = (format = 'jpg', url = '') => (format === 'auto' ? getExt(url) : format);

const getSourceString = ({ source, url, format }, size) =>
    ({
        'editorial-pages': `${url}?downsize=${size}:*&output-format=${format}`,
        'akamai-ic': `${url}?downsize=${size}:*&output-format=${getFormat(format, url)}`,
        'akamai-im': `${url}?imwidth=${size}`,
        'pd-image': `${url}/${size}`,
        'placeholder-image': `${url}/${size}`
    }[source]);

const isSupportedSource = source => ['editorial-pages', 'akamai-ic', 'akamai-im', 'pd-image', 'placeholder-image'].includes(source);

const dynamicResizingStrategy = (sources, sizes = [200, 320, 640, 1280, 2560]) =>
    isSupportedSource(sources.source) ? sizes.map(size => ({ src: getSourceString(sources, size), size: `${size}w` })) : null;

const explicitStrategy = sources => {
    const sizes = {
        small: '640w',
        medium: '1024w',
        large: '1200w'
    };

    return Object.keys(sources).map(key => ({
        src: sources[key],
        size: sizes[key]
    }));
};

const shouldUseExplicitStrategy = sources => Boolean(sources.small || sources.medium || sources.large);

export default (sources, sizes) => shouldUseExplicitStrategy(sources) ? explicitStrategy(sources) : dynamicResizingStrategy(sources, sizes);
